export function formatLineBreaks(txt) {
  return (txt || '').replace(/\n/g, '<br>')
}

export default {
  formatLineBreaks
}
